import { useEffect, useState } from 'react';
import { company, navLinks } from '../content/site';
import { Arrow } from './Icons';
import { Wordmark } from './Wordmark';
import './Nav.css';

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close the mobile panel once a link has done its job.
  useEffect(() => {
    if (!menuOpen) return;
    const close = () => setMenuOpen(false);
    window.addEventListener('hashchange', close);
    return () => window.removeEventListener('hashchange', close);
  }, [menuOpen]);

  return (
    <header className={`nav ${scrolled ? 'is-scrolled' : ''}`}>
      <div className="container nav__inner">
        <a className="nav__brand" href="#top" aria-label={`${company.name} home`}>
          <Wordmark />
        </a>

        <nav className="nav__links" aria-label="Sections">
          {navLinks.map((link) => (
            <a key={link.href} className="nav__link" href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>

        <div className="nav__actions">
          <a className="btn btn--primary nav__cta" href="#enquire">
            Start a conversation
            <Arrow className="btn__arrow" />
          </a>
          <button
            type="button"
            className="nav__toggle"
            aria-expanded={menuOpen}
            aria-controls="nav-panel"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="visually-hidden">
              {menuOpen ? 'Close menu' : 'Open menu'}
            </span>
            <span className={`nav__burger ${menuOpen ? 'is-open' : ''}`} aria-hidden />
          </button>
        </div>
      </div>

      <div
        id="nav-panel"
        className={`nav__panel ${menuOpen ? 'is-open' : ''}`}
        hidden={!menuOpen}
      >
        <div className="container nav__panel-inner">
          {navLinks.map((link) => (
            <a
              key={link.href}
              className="nav__panel-link"
              href={link.href}
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            className="btn btn--primary btn--block"
            href="#enquire"
            onClick={() => setMenuOpen(false)}
          >
            Start a conversation
          </a>
          <a className="nav__panel-email" href={`mailto:${company.email}`}>
            {company.email}
          </a>
        </div>
      </div>
    </header>
  );
}
